import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse } from "../../../types/APIResponse";
import api from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { Location } from "../../../types";
import { DeleteLocation } from "../../../types/LocationTypes";

// Async Thunks
export const fetchLocations = createAsyncThunk<Location[], void, { rejectValue: string }>("locations/fetchLocations", async (_, { rejectWithValue }) => {
  try {
    const response = await api.get<ApiResponse<Location[]>>(apiEndpoints.location.getAll);
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to fetch locations.");
    }
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const createLocation = createAsyncThunk<Location, Location, { rejectValue: string }>("locations/createLocation", async (newLocationData, { rejectWithValue }) => {
  try {
    const response = await api.post<ApiResponse<Location>>(apiEndpoints.location.create, { data: newLocationData });
    if (response?.success) {
      return response.data;
    } else {
      throw new Error(response.message || "Failed to add location.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const deleteLocation = createAsyncThunk<DeleteLocation, { id: string }, { rejectValue: string }>("locations/deleteLocation", async ({ id }, { rejectWithValue }) => {
  try {
    const response = await api.delete<ApiResponse<DeleteLocation>>(`${apiEndpoints.location.delete}/${id}`);
    if (response?.success) {
      return { ...response.data, id };
    } else {
      throw new Error(response.message || "Failed to delete location.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const updateLocation = createAsyncThunk<Location, Location, { rejectValue: string }>("locations/updateLocation", async (updatedLocationData, { rejectWithValue }) => {
  try {
    const response = await api.put<ApiResponse<Location>>(`${apiEndpoints.location.update}/${updatedLocationData?.id}`, { data: updatedLocationData });
    if (response?.success) {
      return { ...response.data };
    } else {
      throw new Error(response.message || "Failed to update location.");
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});
